module.exports = __webpack_public_path__ + "img/bash.4b847ef2.png";